import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  generateVoEManualreports({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.voeManualOrderReport
    }`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  generateVoEreports({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoEReport.voeOrderReport}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  generateManualreports({ state }, subOrderId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.generatereport
    }/${subOrderId}`
    return axios
      .post(url, subOrderId, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  voeSecuredLink({ state }, OrderId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.getVOEDetails
    }/${OrderId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  async deleteDoc({ state }, payload) {
    console.log(payload)
    let url = `${appConfig.apiEndPoint}${endpoint.VoEReport.deletefile}/${
      payload.orderId
    }/${payload.OrderFileId}`
    console.log(url)
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoEReport.deletefile}/${
          payload.orderId
        }/${payload.OrderFileId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getVoEreverify({ state }, payload) {
    let subOrderId = payload.subOrderId
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.voeReverify
    }?subOrderId=${subOrderId}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVoEManulreverify({ state }, payload) {
    let subOrderId = payload.subOrderId
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.voeManualReverify
    }?subOrderId=${subOrderId}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  verifyVoeOTP({ state }, { orderId, otpnumber }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.voeOtpScreen
    }/${orderId}/${otpnumber}`
    console.log(url)
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  uploadDocument({ state }, { fileDetails } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoEReport.voeuploadDocument}`,
        JSON.stringify(fileDetails),
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  sendSecuredData({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoEReport.voeSecureSubmit}`
    console.log(url)
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  sendSecured({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoEReport.voeSecureSave}`
    console.log(url)
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  voeResendOtp({ state }, { orderId }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.voeResendOtp
    }/${orderId}`
    console.log(url)
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVoErefresh({ state }, payload) {
    let subOrderId = payload.subOrderId
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.voeRefresh
    }?subOrderId=${subOrderId}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchSubOrderDetail({ state }, payload) {
    let subOrderId = payload.subOrderId
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.subOrderDetail
    }?subOrderId=${subOrderId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchAuthFormValidation({ state }, payload) {
    // let customerId = payload.customerId
    let customerUserId = payload.customerUserId

    let url = `${appConfig.apiEndPoint}${
      endpoint.VoEReport.authFormValidation
    }?userId=${customerUserId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVoEOrderHistory(
    { state },
    { orderId, pageSize, pageNumber, sortBy, sortDirection }
  ) {
    console.log(
      `${appConfig.apiEndPoint}${
        endpoint.VoEReport.voeOrderHistory
      }?orderId=${orderId}&PageNumber=${pageNumber}&PageSize=${pageSize}&SortBy=${sortBy}&SortDirection=${sortDirection}`
    )
    return axios(
      `${appConfig.apiEndPoint}${
        endpoint.VoEReport.voeOrderHistory
      }?orderId=${orderId}&PageNumber=${pageNumber}&PageSize=${pageSize}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
      {
        headers: setHeaders(),
      }
    )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVoEOrderManul(
    { state },
    { orderId, pageSize, pageNumber, sortBy, sortDirection }
  ) {
    console.log(
      `${appConfig.apiEndPoint}${
        endpoint.VoEReport.voeManualReverification
      }?orderId=${orderId}&PageNumber=${pageNumber}&PageSize=${pageSize}&SortBy=${sortBy}&SortDirection=${sortDirection}`
    )
    return axios(
      `${appConfig.apiEndPoint}${
        endpoint.VoEReport.voeManualReverification
      }?orderId=${orderId}&PageNumber=${pageNumber}&PageSize=${pageSize}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
      {
        headers: setHeaders(),
      }
    )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVoeProcessing({ state }, requestId) {
    return axios(
      `${appConfig.apiEndPoint}${
        endpoint.VoEReport.voeProcessing
      }/${requestId}`,
      {
        headers: setHeaders(),
      }
    )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  uploadVoeDocument({ state }, fileDetails) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoEReport.uploadVoeDoc}`,
        JSON.stringify(fileDetails),
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  updateVoeManual(
    { state },
    { orderId, VoeManualId, comments, status, files }
  ) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoEReport.updateVoeManual}`,
        {
          orderId,
          VoeManualId,
          comments,
          status,
          files,
        },
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  sendVoeVerification(
    { state },
    {
      orderId,
      VoeManualId,
      fileId,
      fileType,
      userId,
      isExternal,
      isShowDelete,
      orderFileIds,
    }
  ) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoEReport.voeSendVerification}`,
        {
          orderId,
          VoeManualId,
          fileId,
          fileType,
          userId,
          isExternal,
          isShowDelete,
          orderFileIds,
        },
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  fetchPdfForOrderVoe({ state }, { subOrderId, pdfUrl }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoEReport.getPdfForOrderVoe
        }?subOrderId=${subOrderId}&pdfUrl=${pdfUrl}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  const path = window.location.href
  const url = path.includes('voe-otpscreen')
  const urldibuvoe = path.includes('voe-dibuscreen')
  const urldibuvod = path.includes('vod-dibuscreen')
  const urlvoe = path.includes('voe-securedlink')
  const urlvod = path.includes('vod-securedlink')
  if (url || urldibuvoe || urldibuvod || urlvoe || urlvod) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
